import axios from "axios";

import endPoints from "../../../../config/endPoints";

//get all data related to the dashboards
// export const getDashboardData = async () => {
//     return await axios.get(`${endPoints.dashboard}/`);
// };

export const getDailyStatistics = async (deptId, reqBody) => {
    return await axios.post(`${endPoints.dashboard}/daily-trans/${deptId}`, reqBody);
};

export const getMonthlyTransactions = async (deptId, reqBody) => {
    return await axios.post(`${endPoints.dashboard}/monthly-trans/${deptId}`, reqBody);
};

export const getMonthlyRevenue = async (deptId, reqBody) => {
    return await axios.post(`${endPoints.dashboard}/monthly-revs/${deptId}`, reqBody);
};

export const getMonthlyReceipts = async (deptId, reqBody) => {
    return await axios.post(`${endPoints.dashboard}/monthly-trans-by-status/${deptId}`, reqBody);
};

// /dashboards/monthly-trans-by-status
// /dashboards/daily-trans
// /dashboards/monthly-trans
// /dashboards/monthly-revs